<fgb-mobile-nav-menu></fgb-mobile-nav-menu>
<div class="mobile-container">
  <div class="container mt-lg-4 mt-3">
    <a class="back-btn text-danger d-flex align-items-center mb-3 cursor-pointer" (click)="back()">
      <i class="material-icons">chevron_left</i>
      <span class="fw-bold font-size-14">{{ 'tickets.page.back.button' | translate }}</span>
    </a>
    <fgbcl-contacts-management></fgbcl-contacts-management>
  </div>
</div>
